<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsSelect',
  
})
</script>
<template>
  <div class="tlbs-select-container">
    <t-select
      class="tlbs-select"
      v-bind="inputAttrs"
      :model-value="initVal"
      :teleported="false"
      @change="onChange"
    >
      <template v-if="Array.isArray(props.options) && props.options.length">
        <t-option
          v-for="item in props.options"
          :key="item.label"
          :value="item.value"
          :label="item.label"
        >
          <div>{{ item.label }}</div>
          <div>{{ item.subLabel }}</div>
        </t-option>
      </template>
      <slot v-else />
      <template #empty>
        <slot name="empty" />
      </template>
    </t-select>
    <div />
  </div>
</template>

<script lang="ts" setup name="TlbsSelect">
// import { ElSelect, ElOption } from 'element-plus';
// import { Select, Option, OptionGroup} from 'tdesign-vue-next';

interface Option {
  value: string | number | boolean | object;
  label: string;
  subLabel?: string;
}

interface Props {
  modelValue: string | number | boolean | object;
  options?: Option[];
}
const attrs = useAttrs();
// class 和 id不透出
const inputAttrs = computed(() => {
  const returnObj = {};
  for (const attr in attrs) {
    if (!['class', 'id'].includes(attr)) {
      returnObj[attr] = attrs[attr];
    }
  }
  return returnObj;
});
console.log('attrs', attrs);
const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
});
const emit = defineEmits<(e: 'update:modelValue' | 'change', value: string | number | boolean | object | []) => void>();

const initVal = ref(props.modelValue);

watch(() => props.modelValue, (newVal) => {
  initVal.value = newVal;
  emit('update:modelValue', newVal);
});

const onChange = (value: string | number | boolean | object) => {
  initVal.value = value;
  emit('update:modelValue', value);
  emit('change', value);
};
</script>
<style lang="less" scoped>
.tlbs-slider-container {
  display: inline-block;
}
</style>
